export const ORIENTATION = {
  WIDE: 'wide',
  SQUARE: 'square',
  AUTO: 'auto',
};

export const SCREEN_RATIO = {
  wide: {
    widthRatio: 16,
    heightRatio: 9,
    maxValue: 80,
    minValue: 45,
  },
  square: {
    widthRatio: 1,
    heightRatio: 1,
    maxValue: 750,
    minValue: 280,
  },
};

export const getMinSquareDimention = () => {
  return {height: 280, width: 280};
};

export const getMinWideDimention = () => {
  return {height: 45 * 9, width: 45 * 16};
};

export const DEFAULT_DIMENSION_UPDATE_EVENT = {
  target: window,
};

export const EVENT_RESIZE = 'resize';

export function calculateDimentions(blockRef, orientation) {
  const ratioValues = SCREEN_RATIO[orientation];
  const {clientWidth: width} = blockRef.current;
  const rateValue = width / ratioValues.widthRatio;
  const height = rateValue * ratioValues.heightRatio;
  return {height, width};
}
